<div class="filter-bar ion-padding-horizontal ion-padding-top">
  <!-- Slot for page-specific actions (e.g. tasks' "Nieuwe klus" button)
       that should sit on the same row as the filter button. -->
  <ng-content></ng-content>

  <!-- Filter button -->
  <ion-button (click)="openFilterModal()"
    [fill]="isFilterActive() ? 'solid' : 'outline'"
    [color]="color()"
    size="small"
    data-cy="filter-button">
    <ion-icon [name]="filterIcon()" slot="start"></ion-icon>
    Filter
  </ion-button>

  <!-- Selected filter chips -->
  @if (selectedShowChips().length > 0) {
    <div class="filter-chips">
      @for (chip of selectedShowChips(); track chip.id) {
        <ion-chip [color]="color()" (click)="removeShowFromFilter(chip.id)">
          <ion-label>{{ chip.name }}</ion-label>
          <ion-icon name="close-circle"></ion-icon>
        </ion-chip>
      }
    </div>
  }

  <!-- Active show indicator (no remove option) -->
  @if (currentFilter().displayMode === 'active-show') {
    <ion-chip color="medium" class="active-show-chip">
      <ion-label>{{ activeShowName() }}</ion-label>
    </ion-chip>
  }

  <!-- "All shows" indicator -->
  @if (currentFilter().displayMode === 'all-shows') {
    <ion-chip [color]="color()" (click)="clearFilter()">
      <ion-label>Alle producties</ion-label>
      <ion-icon name="close-circle"></ion-icon>
    </ion-chip>
  }
</div>
